// 基础
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
// 首页
import HomeIndex from '../view/home/index'
import Home from '../view/home/home'
import Items from '../view/home/secondTab'

// 路由文件
import Login from './login.js'
import Benefit from './benefit'
import third from './thiird'
import my from './my'

// 云店首页
const benefit = resolve => require(['../view/benefit/index'], resolve)
// 搜索
const Search = resolve => require(['../view/home/searchHistory'], resolve)
const searchList = resolve => require(['../view/home/searchList'], resolve)
const citySearch = resolve => require(['../components/citys'], resolve)
// 支付成功页
const success = resolve => require(['../view/my/success'], resolve)
// 商品列表
const List = resolve => require(['../view/home/list'], resolve)
const myCenter = resolve => require(['../view/my/index'], resolve)
const college = resolve => require(['../view/college/index'], resolve)
const rule = resolve => require(['../view/common/rule'], resolve)
const announcementList = resolve => require(['../view/home/announcementList'], resolve)
const error = resolve => require(['../view/common/error'], resolve)
const oauth = resolve => require(['../view/common/oauth'], resolve)
//惠拼优选首页
const huipinSearch = resolve => require(['../view/huipinSearch/index'], resolve)
// 云店铺产品
// const myshop = resolve => require(['../view/agent/myshop'], resolve)
// 赚钱任务默认页index
const moneyTask = resolve => require(['../view/moneyTask/index'], resolve)
//实体店铺管理
const entityshop = resolve => require(['../view/entityshop/index'], resolve)
const stWithdrawList = resolve => require(['../view/entityshop/stWithdrawList'], resolve)
const stShopDesc = resolve => require(['../view/entityshop/stShopDesc'], resolve)
const stErweima = resolve => require(['../view/entityshop/stErweima'], resolve)

const jdDetail=resolve=>require(['../view/union/jd/jdDetail'],resolve)

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}



let routes = [
  {
    path: '/',
    name: 'HomeIndex',
    component: HomeIndex,
    meta: {
      // keepAlive: true
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'benefit',
        name: 'benefit',
        component: benefit,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'my',
        name: 'my',
        component: myCenter,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'college',
        name: 'college',
        component: college,
        meta: {
          // requireAuth: true,
          keepAlive: true
        }
      },
      {
        path: 'huipinSearch',
        name: 'huipinSearch',
        component: huipinSearch,
        meta: {
          // requireAuth: true,
          keepAlive: true
        }
      },
      {
        path: 'entityshop',
        name: 'entityshop',
        component: entityshop,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'stWithdrawList',
        name: 'stWithdrawList',
        component: stWithdrawList,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'stShopDesc',
        name: 'stShopDesc',
        component: stShopDesc,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'stErweima',
        name: 'stErweima',
        component: stErweima,
        meta: {
          // requireAuth: true,
          // keepAlive: true
        }
      },
      {
        path: 'moneyTask',
        name: 'moneyTask',
        component: moneyTask,
        meta: {
          // requireAuth: true,
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/Items',
    name: 'Items',
    component: Items,
    meta: {
      // keepAlive: true
    }
  },
  {
    path: '/Search',
    name: 'Search',
    component: Search,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/List',
    name: 'List',
    component: List,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: searchList,
    meta: {
      keepAlive: true
    }
  },
  // {
  //   path: '/myshop',
  //   name: 'myshop',
  //   component: myshop,
  //   meta: {
  //     keepAlive: true, //该字段表示该页面需要缓存
  //     // isBack: false, //用于判断上一个页面是哪个
  //   }
  // },
  {
    path: '/rule',
    name: 'rule',
    component: rule,
    meta: {
    }
  },
  {
    path: '/announcementList',
    name: 'announcementList',
    component: announcementList,
    meta: {
      keepAlive: announcementList
    }
  },
  {
    path: '/citySearch',
    name: 'citySearch',
    component: citySearch,
    meta: {
      // keepAlive: citySearch
    }
  },
  {
    path: '/successPay',
    name: 'successPay',
    component: success,
    meta: {
      // keepAlive: citySearch
    }
  },
  {
    path: '/oauth',
    name: 'oauth',
    component: oauth,
    meta: {
      // keepAlive: citySearch
    }
  },
  {
    path: '/jdDetail',
    name: 'jdDetail',
    component: jdDetail,
    meta: {
    }
  },
  ...Login.routes,
  ...Benefit.routes,
  ...third.routes,
  ...my.routes,
  {
    path: '*',
    component: error,
    children: [
      {
        path: '*', component: error
      }
    ]
  }
]
const router = new Router({
  mode: 'history',
  // base: '/whsq',
  base: process.env.BASE_URL,
  routes: routes,
  // 切换路由后滚动条置顶
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})
export default router
router.beforeEach((to, from, next) => {
  if (to.query.clearMsg) {
    localStorage.clear()
  }
  // if (localStorage.getItem('version') !== window.g.version) {
  //   localStorage.setItem('version', window.g.version)
  //   location.reload()
  // }else {
  next()
  // }
})



// WEBPACK FOOTER //
// ./src/router/index.js